<template>
  <div
    :class="
      twMerge(
        'tw:border-2 tw:border-blue-700 tw:w-(--base-spinner-size)',
        props.class
      )
    "
    data-testid="base-spinner"
    :style="{ '--base-spinner-size': props.size }"
  />
</template>

<script setup lang="ts">
import { twMerge } from "tailwind-merge";

interface BaseSpinnerProps {
  class?: string;
  size?: string;
}

const props = withDefaults(defineProps<BaseSpinnerProps>(), {
  class: undefined,
  size: "24px",
});
</script>

<style scoped>
div {
  aspect-ratio: 1;
  border-radius: 50%;
  animation:
    timeline1 1s infinite linear alternate,
    timeline2 2s infinite linear;
}

@keyframes timeline1 {
  0% {
    clip-path: polygon(50% 50%, 0 0, 50% 0%, 50% 0%, 50% 0%, 50% 0%, 50% 0%);
  }

  12.5% {
    clip-path: polygon(
      50% 50%,
      0 0,
      50% 0%,
      100% 0%,
      100% 0%,
      100% 0%,
      100% 0%
    );
  }

  25% {
    clip-path: polygon(
      50% 50%,
      0 0,
      50% 0%,
      100% 0%,
      100% 100%,
      100% 100%,
      100% 100%
    );
  }

  50% {
    clip-path: polygon(
      50% 50%,
      0 0,
      50% 0%,
      100% 0%,
      100% 100%,
      50% 100%,
      0% 100%
    );
  }

  62.5% {
    clip-path: polygon(
      50% 50%,
      100% 0,
      100% 0%,
      100% 0%,
      100% 100%,
      50% 100%,
      0% 100%
    );
  }

  75% {
    clip-path: polygon(
      50% 50%,
      100% 100%,
      100% 100%,
      100% 100%,
      100% 100%,
      50% 100%,
      0% 100%
    );
  }

  100% {
    clip-path: polygon(
      50% 50%,
      50% 100%,
      50% 100%,
      50% 100%,
      50% 100%,
      50% 100%,
      0% 100%
    );
  }
}

@keyframes timeline2 {
  0% {
    transform: scaleY(1) rotate(0deg);
  }

  49.99% {
    transform: scaleY(1) rotate(135deg);
  }

  50% {
    transform: scaleY(-1) rotate(0deg);
  }

  100% {
    transform: scaleY(-1) rotate(-135deg);
  }
}
</style>
